// packages/shared-hooks/src/lead-tasks/useCompleteLeadTask.ts
//
// `PATCH /lead-tasks/:id/complete` — idempotent task completion.
// Backend returns 204 No Content; we surface `void` and rely on key
// invalidation to refresh the bucket layout. Mutations on a task can
// remove it from one bucket and surface a sibling row, so we flush
// the whole `lead-tasks` prefix instead of the per-tz slot only.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../api/context.js';
import { leadTasksKeys } from './keys.js';

export function useCompleteLeadTask(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<void, unknown, void>({
    mutationFn: () => client.patch<void>(`/lead-tasks/${id}/complete`, undefined, {}),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadTasksKeys.all });
    },
  });
}
